
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(152|939)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
